import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appointableQueryKeys } from "./appointableQueryKeys";

export const useMutationAppointableCategoryUpdate = ({
  api,
}: {
  api: ApiType;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      params: Parameters<ApiType["appointableApi"]["updateCategory"]>[0],
    ) => (await api.appointableApi.updateCategory(params)).data,
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: appointableQueryKeys.categoriesAll(),
      }),
  });
};
